import { yupResolver } from "@hookform/resolvers/yup";
import "cleave.js/dist/addons/cleave-phone.np.js";
import { KeyRound, Mail, PhoneIcon, User, User2Icon } from "lucide-react";
import { useForm } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/usePostHook";
import { createFirstUserValidationFrom } from "../../../utils/validationSchema";
import Button from "../../Reusable/Button";
import TextField from "../../Reusable/Form/TextInput";
import NumberField from "../../Reusable/NumberField";

const CreateUser = (props: any) => {
  const { setError, handleSubmit, control } = useForm({
    resolver: yupResolver(createFirstUserValidationFrom),
  });

  const { setOpencreateUserPopup, openCreateUserPopup } = props;

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["create-user"],
    navigateURL: "",
  });

  const handleCreateUser = async (values: any, setError: any) => {
    const url = `${APIS.FIRST_USER}`;
    let formData = {
      ...values,
      mobile_number: `+977${values?.mobile_number}`,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpencreateUserPopup(!openCreateUserPopup);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handleCreateUser(data, setError))}
        autoComplete="off"
      >
        <div className={tw`grid grid-cols-2 gap-x-4 px-4 `}>
          <TextField
            label={"Username"}
            icon={<User color="gray" strokeWidth={2} />}
            name="username"
            control={control}
          />
          <TextField
            label={"Email"}
            icon={<Mail color="gray" strokeWidth={2} />}
            name="email"
            control={control}
          />
          <TextField
            label={"Full Name"}
            icon={<User2Icon color="gray" strokeWidth={2} />}
            name="full_name"
            control={control}
          />
          <NumberField
            name="mobile_number"
            label="Phone Number"
            options={{
              numeral: true,
              numeralDecimalMark: ".",
              numeralDecimalScale: 0,
              numeralPositiveOnly: true,
              delimiter: "",
            }}
            control={control}
            icon={<PhoneIcon color="gray" strokeWidth={2} />}
          />
          <TextField
            label={"Password"}
            icon={<KeyRound color="gray" strokeWidth={2} />}
            name="password"
            control={control}
          />
          <TextField
            label={"Confirm Password"}
            icon={<KeyRound color="gray" strokeWidth={2} />}
            name="confirm_password"
            control={control}
          />
        </div>
        <div className={tw`w-full flex justify-end`}>
          <div className={tw`w-32`}>
            <Button label={"Create"} isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateUser;
